import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
  Grid,
} from "@mui/material";
import socketService from "../socket/newsocketService";

import WarningIcon from "@mui/icons-material/Warning";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import PersonIcon from "@mui/icons-material/Person";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PhoneIcon from "@mui/icons-material/Phone";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { GoogleMap, Marker, Circle } from "@react-google-maps/api";
import { toast } from "react-toastify";

export default function GeofenceModal({ open, onClose, data }) {
  const [timer, setTimer] = useState(118);

  // ✅ Proper timer (NO React error)
  useEffect(() => {
    if (!open) return;

    setTimer(118);

    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    // ✅ close handled separately (IMPORTANT)
    const timeout = setTimeout(() => {
      onClose();
    }, 118000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [open, onClose]);

  const formatTime = () => {
    const min = String(Math.floor(timer / 60)).padStart(2, "0");
    const sec = String(timer % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  // ✅ Map style
  const mapContainerStyle = {
    width: "100%",
    height: "180px",
  };

  // ✅ Coordinates safe
  const center = {
    lat: Number(data?.lat) || 0,
    lng: Number(data?.lng) || 0,
  };

  // ✅ Radius safe
  const radius = Number(data?.radius || 0);

  // ✅ View map fix
  const handleViewMap = () => {
    const lat = Number(data?.currentLat || data?.lat);
    const lng = Number(data?.currentLong || data?.lng);

    if (lat && lng) {
      window.open(`https://www.google.com/maps?q=${lat},${lng}`, "_blank");
    }
  };
  const handleDispatch = (vehicleData) => {
    console.log("Dispatching with payload:", vehicleData);
    const payload = {
      alert_type: "Emergency",
      alert_message: "Vehicle breached geofence",

      Latitude: Number(vehicleData?.currentLat || vehicleData?.lat),
      Longitude: Number(vehicleData?.currentLong || vehicleData?.lng),

      isRead: true,

      user_Img: vehicleData?.profile || "",
      user_Name: vehicleData?.ownerName || "",
      user_Phone: vehicleData?.phone,

      vehicleName: vehicleData?.vehicleNickname || "",
      vehicleNumber: vehicleData?.licensePlate || "",

      timestamp: vehicleData?.createdAt,
      userId: vehicleData?.userId,
    };
    console.log("Dispatching with payload:", payload);
    socketService.emit("sendalert", {
      payload,
      isBroadcast: false,
    });
    console.log("Alert emitted to Vigilanteye");
    toast.info("Security dispatched");
  };

  if (!data) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {/* Header */}
      <Box
        sx={{
          background: "linear-gradient(90deg, #f7b500, #fcd34d)",
          display: "flex",
          alignItems: "center",
          gap: 1,
          p: 2,
        }}
      >
        <WarningIcon />
        <Typography fontWeight="bold">GEOFENCE BREACH!</Typography>
      </Box>

      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Vehicle has exited the geofenced area!
        </Typography>

        {/* Details */}
        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DirectionsCarIcon />
            <Typography>
              Vehicle: <b>{data?.vehicleNickname}</b>
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
            <PersonIcon />
            <Typography>{data?.phone}</Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
            <LocationOnIcon color="error" />
            <Typography onClick={handleViewMap} sx={{ cursor: "pointer" }}>
              <b>{data?.location}</b>
              <span style={{ color: "blue", marginLeft: 8 }}>
                View on Map
              </span>
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
            <AccessTimeIcon />
            <Typography>
              {new Date(data?.createdAt).toLocaleString()}
            </Typography>
          </Box>
        </Box>

        {/* ✅ MAP */}
        <Box
          sx={{
            height: 180,
            borderRadius: 2,
            overflow: "hidden",
            mb: 2,
          }}
        >
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={center}
            zoom={15} // 👈 better for radius visibility
          >
            <Marker position={center} />

            {radius > 0 && (
              <Circle
                center={center}
                radius={radius}
                options={{
                  strokeColor: "#FF0000",
                  strokeOpacity: 1,
                  strokeWeight: 3,
                  fillColor: "#FF0000",
                  fillOpacity: 0.35,
                }}
              />
            )}
          </GoogleMap>
        </Box>

        {/* Timer + Dispatch */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <Box
            sx={{
              width: 70,
              height: 70,
              borderRadius: "50%",
              border: "6px solid #6366f1",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
            {formatTime()}
          </Box>

          <Button
            fullWidth
            sx={{
              background: "linear-gradient(90deg, #111827, #1f2937)",
              color: "#fff",
              py: 1.5,
              borderRadius: 2,
            }}
            onClick={() => handleDispatch(data)}
          >
            DISPATCH TO VIGILANTEYE
          </Button>
        </Box>

        {/* Actions */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button
              fullWidth
              startIcon={<PowerSettingsNewIcon />}
              sx={{ background: "#111827", color: "#fff" }}
            >
              Disable Engine
            </Button>
          </Grid>

          <Grid item xs={6}>
            <Button
              fullWidth
              startIcon={<PhoneIcon />}
              sx={{ background: "#111827", color: "#fff" }}
              onClick={() => {
                navigator.clipboard.writeText(data.phone);
                alert(`Copied: ${data?.phone}`);
              }}
            >
              Call Owner
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}